import React from "react";
import Skeleton from "react-loading-skeleton";

const HelpMessageLoading = () => {
  return (
    <>
      <div className="unique_message_box">
        <div className="message-sender">
          <Skeleton />
        </div>
      </div>
    </>
  );
};

export default HelpMessageLoading;
